import React, { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';

import { selectCompanyRegistration } from '../../redux/preferences/selectors';
import RegistrationContext from './RegistrationContext';

const RegistrationProvider = ({ children }: PropsWithChildren<any>) => {
  const reduxState = useSelector(selectCompanyRegistration);

  return <RegistrationContext.Provider value={reduxState}>{children}</RegistrationContext.Provider>;
};

export default RegistrationProvider;
